<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.reservation">
  <app-activate-service *ngIf="!isEnabled && businessId!='' && businessId != '0'" [businessId]="businessId"
    [additionalServiceType]="2" (onActivated)="onLoad()" [ctryCode]="ctryCode" [userId]="userId" />
  <div style="max-width:1000px;" class="center" [ngClass]="seats && seats.groups.length > 0 ? 'banner' : ''"
    *ngIf="isEnabled && (interactionType != 1 || (interactionType == 1 && activeSessions && activeSessions.sessions &&activeSessions.sessions.length > 0))">
    <div *ngIf="interactionType != 1 && seats && seats.groups.length == 0">
      <div class="row">
        <div class="col-12" style="text-align: center;">
          <br />
          <br />
          <button class="btn btn-primary" title="{{localService.languageContent.reservation.header}}"
            (click)="onAction(1)"
            style="margin-top: -15px;">{{localService.languageContent.reservation.header}}</button>
        </div>
      </div>
    </div>
    <div *ngIf="interactionType != 1 && seats && seats.groups.length > 0">
      <div *ngIf="!isLiveMode">
        <div class="row freeze_height">
          <div class="col-12" style="text-align: right;">
            <button class="button_icon button_icon_color " style="top: 0px; color: red !important"
              title="{{localService.languageContent.reservation.switch_to_live_mode}}"
              (click)="onAction(9)">history</button>
          </div>
        </div>
      </div>
      <div *ngIf="isLiveMode">
        <div class="row freeze_height">
          <div [ngClass]="isTableMode ? 'col-12' :'col-md-6' ">
            <div class="row">
              <div class="col-8">
                <label style="font-weight: normal; margin-left: 15px;">
                  <input type="checkbox" [(ngModel)]="isTableMode" (change)="onSaveLastUsedSettings()" />
                  <span class="normal_color">{{localService.languageContent.reservation.table_mode}}</span>
                </label>
              </div>
              <div class="col-4" style="text-align: right;">
                <button *ngIf="!isTableMode" class="btn btn-primary"
                  title="{{localService.languageContent.reservation.queue}}"
                  (click)="onAction(8)">{{localService.languageContent.reservation.queue}}</button>
                <button *ngIf="isTableMode" class="button_icon button_icon_color " style="top: 0px;"
                  (click)="onLoad()">replay_circle_filled</button>
              </div>
            </div>
          </div>
          <div class="col-md-6" style="text-align: right;" *ngIf="!isTableMode">
            <button class="btn btn-primary" title="{{localService.languageContent.reservation.header}}"
              (click)="onAction(1)"
              style="margin-top: -15px;">{{localService.languageContent.reservation.header}}</button>
            &nbsp;
            <button class="button_icon button_icon_color " style="top: 0px;"
              (click)="onLoad()">replay_circle_filled</button>
            <button class="button_icon button_icon_color " style="top:0px;"
              title="{{localService.languageContent.reservation.switch_to_live_mode}}"
              (click)="onAction(9)">history</button>
          </div>
        </div>
        <div class="row freeze_height" *ngIf="!isTableMode">
          <div class="col-3">
            <button class="btn btn-primary" title="{{localService.languageContent.reservation.new_session}}"
              (click)="onAction(3)"
              style="height: 100%;width: 100%;">{{localService.languageContent.reservation.new_session}}</button>
          </div>
          <div class="col-3">
            <button class="btn btn-primary" title="{{localService.languageContent.reservation.view_session}}"
              (click)="onAction(5)"
              style="height: 100%;width: 100%;">{{localService.languageContent.reservation.view_session}}</button>
          </div>
          <div class="col-3">
            <button class="btn btn-primary" style="height: 100%;width: 100%;background-color:red !important"
              title="{{localService.languageContent.reservation.clear_session}}"
              (click)="onAction(6)">{{localService.languageContent.reservation.clear_session}}</button>
          </div>
          <div class="col-3">
            <button *ngIf="isElligibleForBill" class="btn btn-primary"
              title="{{localService.languageContent.reservation.attach_bill}}" (click)="onAction(4)"
              style="height: 100%;width: 100%;">{{localService.languageContent.reservation.attach_bill}}</button>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="isTableMode && isLiveMode && seats" class="table_mode_container"
      [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
      <div class="box table_mode" *ngFor="let item of seats.groups;">
        <div class="row">
          <div class="col-6 en" style="text-align:right;">
            <div class="table-name">
              <button class="btn" (click)="onAction(13,item.key)"
                title="{{localService.languageContent.common.attach_table_bill}}">
                <span>{{item.v1}}</span>&nbsp;
                <i class="material-icons menu_icon table-name-icon">add_circle_outline</i></button>
            </div>
          </div>
          <div class="col-6">
            <div class="table-billid">
              <div *ngFor="let tableBillId of onGetTableBills(item.key)">
                <button class="button_icon button_icon_color" style="top:0px"
                  title="{{localService.languageContent.reservation.attach_table_bill}}"
                  (click)="onAction(10,item.key,tableBillId)">
                  receipt
                </button>
                <button class="button_icon button_icon_color" style="top:0px"
                  title="{{localService.languageContent.reservation.view_table_bill}}"
                  (click)="onAction(11,tableBillId)">
                  preview
                </button>
                <button class="button_icon " style="color: red;"
                  title="{{localService.languageContent.reservation.detach_table_bill}}"
                  (click)="onAction(12,item.key,tableBillId)">
                  remove_circle_outline
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!isTableMode && isLiveMode && seats" class="custom_rows_body"
      [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
      <div class="seat_availability" *ngFor="let item of seats.groups;">
        <div class="row styled_row">
          <div class="col-3 en" style="text-align:right;">
            <div class="table-name">
              <button class="button_icon button_icon_color icon_adjust" style="margin-left: 10px;"
                (click)="onGenerateBarCode(item.key)">qr_code_scanner</button>
              <span>{{item.v1}}</span>
              <button class="button_icon button_icon_color table-name-icon" (click)="onAction(13,item.key)"
                title="{{localService.languageContent.common.attach_table_bill}}">add_circle_outline</button>
            </div>
            <div class="table-billid">
              <div *ngFor="let tableBillId of onGetTableBills(item.key)">
                <button class="button_icon button_icon_color" style="top:0px"
                  title="{{localService.languageContent.reservation.attach_table_bill}}"
                  (click)="onAction(10,item.key,tableBillId)">
                  receipt
                </button>
                <button class="button_icon button_icon_color" style="top:0px"
                  title="{{localService.languageContent.reservation.view_table_bill}}"
                  (click)="onAction(11,tableBillId)">
                  preview
                </button>
                <button class="button_icon " style="color: red;"
                  title="{{localService.languageContent.reservation.detach_table_bill}}"
                  (click)="onAction(12,item.key,tableBillId)">
                  remove_circle_outline
                </button>
              </div>
            </div>
          </div>
          <div class="col-9">
            <app-seat-arrangements [seatsStatusAndTitle]="onGetSeatArrangement(item.key)" [seatTypeStr]="item.v2"
              (onSeatSelected)="onAction(7,$event)"></app-seat-arrangements>
          </div>
        </div>
        <div *ngIf="selectedTableId == item.key" style="text-align: center;width: 100%;">
          <div style="max-width: 400px;margin: auto;">
            <app-qrcode-generator [value]="businessId" [businessId]="businessId" [categoryCode]="categoryCode"
              [countryCode]="localService.selected.countryCode" [tableId]="item.key" [isShowLabelPrint]="true" />
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!isLiveMode && activeSessions" class="custom_rows_body"
      [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
      <div *ngFor="let item of activeSessions.sessions">
        <div class="box" *ngIf="ignoreSessionIds.indexOf(item.key) == -1">
          <div class="row">
            <div class="col-4 en">
              <span>{{item.v1}}</span>
            </div>
            <div class="col-5">
              <span class="en">{{item.v5 | localDate}}</span>
            </div>
            <div class="col-3" style="text-align:right;">
              <button class="button_icon button_icon_color" *ngIf="!isSeatsLoaded(item.key)"
                (click)="onActionSession(3,item.key)">airline_seat_recline_normal</button>
              <button class="button_icon button_icon_color" *ngIf="!isBillsLoaded(item.key) && item.v8 == '2'"
                (click)="onActionSession(8,item.key)">receipt</button>
            </div>
          </div>
          <div class="row" *ngIf="item.v4 != '' || interactionType == 1">
            <div class="col-12">
              <span *ngIf="interactionType != 1 && item.v2 == ''" class="en">{{item.v4}}</span>
              <span *ngIf="interactionType != 1 && item.v2 != ''" class="button"
                (click)="localService.showSummary(item.v2, 1)"
                [ngClass]="localService.getLanguageCode(item.v3)">{{item.v4}}</span>
              <span *ngIf="interactionType == 1" class="button"
                (click)="localService.showSummary(item.v8, item.v7 == '2' ? 2 : 4)"
                [ngClass]="localService.getLanguageCode(item.v9)">{{item.v10}}</span>
            </div>
          </div>
          <div class="row" *ngFor="let itemSub of onGetSeats(item.key);">
            <div class="col-3 en" style="text-align:right;">
              {{itemSub.v1}}
            </div>
            <div class="col-9">
              <app-seat-arrangements [seatsStatusAndTitle]="onGetSeatArrangementBySessionId(item.key,itemSub.key)"
                [seatTypeStr]="itemSub.v2"></app-seat-arrangements>
            </div>
          </div>
          <div class="row" *ngFor="let itemSub of onGetBills(item.key);">
            <div class="col-6 en">
              <i class="material-icons icon_adjust" (click)="onAction(9,itemSub.key)">print</i>
              &nbsp;
              <span class="button" (click)="onActionSession(10,itemSub.key)">{{itemSub.value}}</span>
            </div>
            <div class="col-6" style="text-align:right;">

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-paging *ngIf="isEnabled && !isLiveMode && activeSessions" [paging]="wrappers.paging"
    (onPagingRefreshed)="onLoad()"></app-paging>
</div>
<div>
  <app-message-box *ngIf="isOpenDeleteConfirmationBox" [message]="deleteConfirmationMessage" [IsConfirmationType]="true"
    (onClose)="onDelete($event)" [IsPopup]="true" [IsHtmlMessage]="true" />
</div>